import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="15" y="18" width="6" height="2"/><rect x="11" y="18" width="2" height="2"/><rect x="11" y="22" width="2" height="2"/><path d="M18,12a1,1,0,0,1-1-1V2H7A2.006,2.006,0,0,0,5,4V28a2.006,2.006,0,0,0,2,2H25a2.006,2.006,0,0,0,2-2V12Zm5,12.5A1.5,1.5,0,0,1,21.5,26h-11A1.5,1.5,0,0,1,9,24.5v-9A1.5,1.5,0,0,1,10.5,14h11A1.5,1.5,0,0,1,23,15.5Z"/><rect x="15" y="22" width="6" height="2"/><path d="M26,8.59l-.29-.3-5-5L20.41,3A3.443,3.443,0,0,0,19,2.19V10h7.81A3.443,3.443,0,0,0,26,8.59Z"/>';
export var FileSpreadsheetSVG = function FileSpreadsheetSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
FileSpreadsheetSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FileSpreadsheetSVG);